export const CLARITY_EVENTS = {
	// Eventos de navegación
	PAGE_VIEW: 'page_view',
	BUTTON_CLICK: 'button_click',
	LINK_CLICK: 'link_click',

	// Eventos de usuario
	USER_LOGIN: 'user_login',
	USER_LOGOUT: 'user_logout',
	USER_REGISTER: 'user_register',

	// Eventos de formularios
	FORM_START: 'form_start',
	FORM_COMPLETE: 'form_complete',
	FORM_ERROR: 'form_error',

	// Eventos de compra
	ADD_TO_CART: 'add_to_cart',
	REMOVE_FROM_CART: 'remove_from_cart',
	CHECKOUT_START: 'checkout_start',
	CHECKOUT_COMPLETE: 'checkout_complete',

	// Eventos personalizados
	CUSTOM_EVENT: 'custom_event',

	// New linking flow
	NEW_LINKING_PAGE_VIEW: 'new_linking_page_view',
	NEW_LINKING_CLOSE_MODAL_FAILED: 'new_linking_close_modal_failed',
	NEW_LINKING_USER_WANT_HELP: 'new_linking_user_want_help',
	NEW_LINKING_SUCCESS_MODAL: 'new_linking_success_modal',
} as const;
